import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEquiposRadiologicos, postEquiposRadiologicos } from "../../../../../../../../../redux/actions/resolucion";
import EquipoRadiologicoForm from "./equipoRadiologicoForm";
import EquipoRadiologicoSelector from "./EquipoRadiologicoSelector";

const initialValues = {
    marca: "",
    modelo: "",
    idTipoEquipoRadiologico: null,
    idCaracteristicaEquipoRadiologico: null,
    idTipoRadiacion: null,
    actividad: "",
    radioisotipoFuente: "",
    idTipoFuente: null,
    potenciaEquipoKVP: "",
    potenciaEquipomAp: "",
    potenciaEquipoMeV: "",
    idTipoMetodoProcesamientoImagen: null,
    procesamientoImagenes: false,
    observaciones: "",
};


const EquipoRadiologicoFormContainer = () => {
    const dispatch = useDispatch();
    const idDependenciaEmpleador = useSelector(
        (state) => state.resolucion.searchedEstablecimiento
    );


    const [openEquipoRadiologicoForm, setOpenEquipoRadiologicoForm] =
        useState(false);

    const handleOpenNewEquipoRadiologicoDialog = () => {
        setOpenEquipoRadiologicoForm(true);
    };

    const handleSubmitEquipoRadiologico = (values) => {
        const body = {
            ...values,
            idDependenciaEmpleador: idDependenciaEmpleador,
            procesamientoImagenes: values.procesamientoImagenes ? 1 : 0,
            potenciaEquipoKVP: parseFloat(values.potenciaEquipoKVP.replace(",", ".")),
            potenciaEquipomAp: parseFloat(values.potenciaEquipomAp.replace(",", ".")),
            potenciaEquipoMeV: parseFloat(values.potenciaEquipoMeV.replace(",", ".")),
        };
        dispatch(postEquiposRadiologicos(body)).then(() => {
            dispatch(getEquiposRadiologicos(idDependenciaEmpleador))
        });
        setOpenEquipoRadiologicoForm(false);
    };

    return (
        <>
            <EquipoRadiologicoSelector
                handleOpen={handleOpenNewEquipoRadiologicoDialog}
            />


            <EquipoRadiologicoForm
                open={openEquipoRadiologicoForm}
                handleClose={() => setOpenEquipoRadiologicoForm(false)}
                handleSubmit={handleSubmitEquipoRadiologico}
                values={initialValues} // No tiene editar. Asi que siempre son intial values

            />
        </>

    )

}


export default EquipoRadiologicoFormContainer; 